<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">Calendar</h3>
      </div>
      <div class="content-header-right col-md-8 col-12">
        <div class="breadcrumbs-top">
          <div class="breadcrumb-wrapper mr-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
              <li class="breadcrumb-item"><router-link to="/calendar">Calendar</router-link></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <p><strong>Select Order Date</strong></p>
              <div class="row">
                <div class="col-12" v-for="day in days" v-bind:key="day.day">
                  <div class="calendar-block text-center match-height" v-on:click="setPreOrderDate(day)">
                    <div class="activity-indicator" v-if="day.orders"></div>
                    <i class="la la-calendar calendar-icon"></i><br />
                    <strong style="font-size:20px">{{day.day_name}}</strong><br />
                    <div style="font-size:14px">{{day.month_name}} {{day.day}}, {{day.year}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'calendar',
  data: function () {
    return {
      days: []
    }
  },
  mounted: function () {
    localStorage.removeItem('boardroomId')
    localStorage.removeItem('boardroomTime')

    var that = this
    var user = JSON.parse(window.localStorage.getItem('user'))
    var parentId = user.parent.id
    var merchantId = window.localStorage.getItem('merchantId')

    $.ajax({
      beforeSend: function (xhr) {
        $.showLoading()
        if (window.localStorage.getItem('token')) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        }
      },
      complete: function () {
        $.hideLoading()
      },
      url: this.$config.apiUrl + 'canteenapp_parents/calendar?parent_id=' + parentId + '&merchant_id=' + merchantId,
      type: 'get',
      dataType: 'json',
      success: function (data) {
        that.days = data.data.calendar

        setTimeout(function () {
          $('.match-height').matchHeight()
        }, 1000)
      }
    })
  },
  methods: {
    setPreOrderDate: function (day) {
      console.log('SELECTED FORMAT: ' + day.date)
      console.log('DATE:' + moment().format('YYYY-MM-DD'))

      if (moment().format('YYYY-MM-DD') === day.date) {
        swal({
          title: 'Error',
          text: 'Sorry you need to place orders by 3pm on the previous day',
          icon: 'error',
          button: 'Ok'
        })

        return false
      }

      var currentUnix = Math.floor(Date.now() / 1000)
      var targetUnix = moment(day.date + ' 15:00').format('X')

      if (targetUnix - currentUnix <= 86400) {
        swal({
          title: 'Error',
          text: 'Sorry you need to place orders for tomorrow by 3pm today',
          icon: 'error',
          button: 'Ok'
        })

        return false
      }

      this.$router.push('/preorder/' + day.date)
    }
  },
  computed: {
    balance: function () {
      var user = JSON.parse(window.localStorage.getItem('user'))
      return user.wallet_balance
    }
  }
}
</script>

<style scoped>
.calendar-block {
  display:block;
  background:#EEE;
  box-sizing: border-box;
  padding:10px;
  margin-bottom:15px;
  font-size:0.7em;
}
.calendar-block i {
  font-size:3em;
}
.activity-indicator {
  width:5px;
  height:5px;
  border-radius:100%;
  background:#FF4259;
  position:absolute;
  right:25px;
}
</style>
